import { createSvgIcon } from '@mui/material';

export const CellIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 13H12"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 17H16"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'CellIcon'
);

export const ChecklistIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M12.3701 8.87988H17.6201"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.37988 8.87988L7.12988 9.62988L9.37988 7.37988"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3701 15.8799H17.6201"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.37988 15.8799L7.12988 16.6299L9.37988 14.3799"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'CellIcon'
);

export const ChevronDown = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M6 9L12 15L18 9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'ChevronDown'
);

export const ChevronRight = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M9.5 18L15.5 12L9.5 6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'ChevronRight'
);

export const ChevronLeft = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M15 18L9 12L15 6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'ChevronLeft'
);

export const ChevronUp = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M18 15L12 9L6 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'ChevronUp'
);

export const Dashboard = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M8.557 2.75H4.682C4.42829 2.75 4.17706 2.79997 3.94266 2.89706C3.70825 2.99416 3.49527 3.13647 3.31587 3.31587C3.13647 3.49527 2.99416 3.70825 2.89706 3.94266C2.79997 4.17706 2.75 4.42829 2.75 4.682V8.557C2.74999 9.07032 2.95322 9.56277 3.31526 9.92668C3.67729 10.2906 4.16868 10.4964 4.682 10.499H8.557C9.07205 10.499 9.56601 10.2944 9.9302 9.9302C10.2944 9.56601 10.499 9.07205 10.499 8.557V4.682C10.4964 4.16868 10.2906 3.67729 9.92668 3.31526C9.56277 2.95322 9.07032 2.74999 8.557 2.75Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.318 2.75H15.443C14.9297 2.74999 14.4372 2.95322 14.0733 3.31526C13.7094 3.67729 13.5036 4.16868 13.501 4.682V8.557C13.5012 9.07197 13.7059 9.56577 14.0701 9.92991C14.4342 10.294 14.928 10.4987 15.443 10.499H19.318C19.8313 10.4964 20.3227 10.2906 20.6847 9.92668C21.0468 9.56277 21.25 9.07032 21.25 8.557V4.682C21.25 4.1696 21.0464 3.67819 20.6841 3.31587C20.3218 2.95355 19.8304 2.75 19.318 2.75Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.557 13.5H4.682C4.16859 13.5029 3.6772 13.7089 3.3152 14.073C2.95319 14.437 2.74999 14.9296 2.75 15.443V19.318C2.75 19.8304 2.95355 20.3218 3.31587 20.6841C3.67819 21.0464 4.1696 21.25 4.682 21.25H8.557C9.07032 21.25 9.56277 21.0468 9.92668 20.6847C10.2906 20.3227 10.4964 19.8313 10.499 19.318V15.443C10.499 14.9279 10.2944 14.434 9.9302 14.0698C9.56601 13.7056 9.07205 13.501 8.557 13.501V13.5Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.375 13.5C16.8661 13.5 16.3622 13.6002 15.8921 13.795C15.422 13.9897 14.9948 14.2751 14.635 14.635C14.2751 14.9948 13.9897 15.422 13.795 15.8921C13.6002 16.3622 13.5 16.8661 13.5 17.375C13.5 17.8839 13.6002 18.3878 13.795 18.8579C13.9897 19.328 14.2751 19.7552 14.635 20.115C14.9948 20.4749 15.422 20.7603 15.8921 20.955C16.3622 21.1498 16.8661 21.25 17.375 21.25C18.4027 21.25 19.3883 20.8417 20.115 20.115C20.8417 19.3883 21.25 18.4027 21.25 17.375C21.25 16.3473 20.8417 15.3617 20.115 14.635C19.3883 13.9083 18.4027 13.5 17.375 13.5Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'Dashboard'
);

export const DashboardFilled = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path d="M10.5 4.68117L10.5 8.55917C10.5 8.55934 10.5 8.55952 10.5 8.5597C10.4993 8.94413 10.3849 9.31977 10.1713 9.6394C9.9577 9.959 9.65443 10.2083 9.29958 10.3561C9.06586 10.4524 8.81535 10.5013 8.56257 10.5H8.56H4.68117C4.16835 10.4977 3.67729 10.2924 3.3154 9.92899C2.9533 9.56539 2.75 9.07315 2.75 8.56V4.69V4.69C2.75 4.17685 2.9533 3.6846 3.3154 3.32101C3.67727 2.95765 4.16829 2.75236 4.68108 2.75H8.56C9.07315 2.75 9.56539 2.9533 9.92899 3.3154C10.2924 3.67729 10.4977 4.16835 10.5 4.68117ZM10.5 4.68117V4.68H11M10.5 4.68117C10.5 4.68146 10.5 4.68176 10.5 4.68205L11 4.68M11 4.68V8.56M11 4.68C10.9974 4.03461 10.7391 3.41655 10.2818 2.96112L11 8.56M11 8.56C10.9992 9.04324 10.8555 9.51544 10.587 9.91722C10.3185 10.319 9.93717 10.6324 9.491 10.818C9.1958 10.9398 8.87933 11.0016 8.56 11L11 8.56ZM2.96112 10.2818C2.50569 9.82451 2.24999 9.2054 2.25 8.56V4.69C2.24999 4.0446 2.50569 3.42549 2.96112 2.96819C3.41655 2.51088 4.03461 2.25265 4.68 2.25L2.96112 10.2818Z" />
        <path
            d="M21.7501 4.69V8.56C21.7516 8.87944 21.6896 9.19601 21.5678 9.49129C21.4459 9.78657 21.2665 10.0547 21.0401 10.28C20.8167 10.5097 20.5491 10.6919 20.2536 10.8156C19.958 10.9393 19.6405 11.0021 19.3201 11H15.4401C14.958 10.9994 14.4867 10.8565 14.0855 10.5894C13.6842 10.3222 13.3706 9.94255 13.1841 9.498C13.0604 9.20083 12.9979 8.88184 13.0001 8.56V4.69C12.9987 4.36969 13.0618 4.05239 13.1855 3.75692C13.3092 3.46146 13.491 3.19385 13.7201 2.97C13.9449 2.74221 14.2127 2.56128 14.5079 2.43769C14.8032 2.3141 15.12 2.25031 15.4401 2.25H19.3201C19.9654 2.25265 20.5835 2.51088 21.0389 2.96819C21.4944 3.42549 21.7501 4.0446 21.7501 4.69Z"
            stroke="none"
        />
        <path
            d="M11 15.45V19.32C10.9974 19.9654 10.7391 20.5835 10.2818 21.0389C9.82454 21.4943 9.20543 21.75 8.56003 21.75H4.68003C4.03563 21.7487 3.41768 21.4937 2.96003 21.04C2.7336 20.8147 2.55422 20.5466 2.43233 20.2513C2.31044 19.956 2.24847 19.6394 2.25003 19.32V15.45C2.24847 15.1306 2.31044 14.814 2.43233 14.5187C2.55422 14.2234 2.7336 13.9553 2.96003 13.73C3.41565 13.2708 4.03322 13.0087 4.68003 13H8.56003C9.20726 13.0053 9.82634 13.2654 10.2831 13.724C10.7398 14.1826 10.9974 14.8028 11 15.45Z"
            stroke="none"
        />
        <path
            d="M21.75 17.38C21.748 18.2434 21.4903 19.087 21.0094 19.8041C20.5284 20.5212 19.8458 21.0797 19.0477 21.4093C18.2496 21.7388 17.3718 21.8245 16.525 21.6555C15.6782 21.4866 14.9005 21.0706 14.29 20.46C13.6794 19.8495 13.2634 19.0718 13.0945 18.225C12.9255 17.3782 13.0112 16.5004 13.3407 15.7023C13.6703 14.9042 14.2288 14.2216 14.9459 13.7406C15.663 13.2597 16.5066 13.002 17.37 13C18.2365 13.0024 19.0829 13.2606 19.8032 13.7422C20.5235 14.2237 21.0856 14.9072 21.419 15.707C21.639 16.237 21.751 16.806 21.75 17.38Z"
            stroke="none"
        />
    </svg>,
    'DashboardFilled'
);

export const FolderIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        width="24"
        height="24"
    >
        <path d="M20.6536 12.1161L20.6559 12.1192C21.0901 12.7067 21.2777 13.4212 21.2008 14.1388L21.2007 14.1388L21.1996 14.1524L20.8299 18.7977C20.7571 19.536 20.6838 20.1759 20.3275 20.6569C20.0029 21.0951 19.3541 21.5021 17.858 21.5021H6.138C4.64181 21.5021 3.9899 21.095 3.66408 20.6572C3.30741 20.1781 3.23358 19.5399 3.16618 18.8093L2.79644 14.1426L2.79654 14.1426L2.79552 14.1323C2.71897 13.3668 2.94725 12.595 3.43975 11.9628C3.68806 11.6553 3.98566 11.4096 4.31505 11.2323L4.31508 11.2323L4.32153 11.2287C4.76768 10.9799 5.25393 10.8521 5.768 10.8521H18.218C18.7343 10.8521 19.2287 10.981 19.6609 11.2267L19.6679 11.2307L19.6751 11.2345C19.9907 11.4006 20.266 11.624 20.5028 11.9088L20.6536 12.1161ZM9.598 17.842H14.388C15.0541 17.842 15.588 17.3082 15.588 16.6421C15.588 15.9906 15.0588 15.4421 14.388 15.4421H9.598C8.92722 15.4421 8.398 15.9906 8.398 16.6421C8.398 17.2935 8.92723 17.842 9.598 17.842Z" />
        <path d="M20.5599 8.596C20.5979 8.979 20.1819 9.236 19.8179 9.113C19.3051 8.94297 18.7681 8.85752 18.2279 8.86H5.76888C5.21288 8.86 4.66488 8.95 4.15288 9.122C3.79288 9.243 3.37988 8.995 3.37988 8.615V6.66C3.37988 3.09 4.46988 2 8.03988 2H9.21988C10.6499 2 11.0999 2.46 11.6799 3.21L12.8799 4.81C13.1299 5.15 13.1399 5.17 13.5799 5.17H15.9599C19.0859 5.17 20.3059 6.007 20.5599 8.596Z" />
    </svg>,
    'FolderIcon'
);

export const DeleteIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M19 4.97998C15.67 4.64998 12.32 4.47998 8.98 4.47998C7 4.47998 5.02 4.57998 3.04 4.77998L1 4.97998"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.5 3.97L6.72 2.66C6.88 1.71 7 1 8.69 1H11.31C13 1 13.13 1.75 13.28 2.67L13.5 3.97"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.8499 8.14014L16.1999 18.2101C16.0899 19.7801 15.9999 21.0001 13.2099 21.0001H6.7899C3.9999 21.0001 3.9099 19.7801 3.7999 18.2101L3.1499 8.14014"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.33008 15.5H11.6601"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 11.5H12.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'DeleteIcon'
);

export const HighlightIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M6.93927 19.8545L5.7247 21H2C2.72874 20.0182 4.59109 18.3818 4.99595 17.8909M6.93927 19.8545C7.47908 19.6364 8.75304 19.2655 9.53036 19.5273C10.3077 19.7891 11.4197 18.8727 11.8785 18.3818M6.93927 19.8545L4.99595 17.8909M11.8785 18.3818L22 7.00909L17.5 2.5L6.69636 13.3091M11.8785 18.3818L6.69636 13.3091M6.69636 13.3091C6.37247 13.5273 5.7247 14.1764 5.7247 15.0273C5.7247 16.0909 5.44187 17.3502 4.99595 17.8909"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path d="M14 21H22" strokeWidth="1.5" strokeLinecap="round" />
    </svg>,
    'HighlightIcon'
);

export const InfoIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'InfoIcon'
);

export const RefreshCCW = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M1 4.00008V10.0001M1 10.0001H7M1 10.0001L5.64 5.64008C6.71475 4.56479 8.04437 3.77928 9.50481 3.35685C10.9652 2.93442 12.5089 2.88883 13.9917 3.22433C15.4745 3.55984 16.8482 4.26551 17.9845 5.27549C19.1209 6.28548 19.9828 7.56686 20.49 9.00008M23 20.0001V14.0001M23 14.0001H17M23 14.0001L18.36 18.3601C17.2853 19.4354 15.9556 20.2209 14.4952 20.6433C13.0348 21.0657 11.4911 21.1113 10.0083 20.7758C8.52547 20.4403 7.1518 19.7346 6.01547 18.7247C4.87913 17.7147 4.01717 16.4333 3.51 15.0001"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'RefreshCCW'
);

export const RoundedHighlight = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        stroke="currentColor"
        viewBox="0 0 24 24"
        width="24"
        height="24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32746 20.9999H3.98753C3.16578 20.9999 2.7573 20.1135 3.34097 19.5351C3.58761 19.2906 3.83567 19.0506 4.06395 18.8297C4.23424 18.6649 4.39353 18.5108 4.53302 18.3734L4.74299 18.5801L6.31918 20.1312L6.47899 20.2885L6.01357 20.7274C5.82799 20.9025 5.58255 20.9999 5.32746 20.9999ZM9.53029 19.5272C8.90267 19.3158 7.95129 19.5169 7.32398 19.717L7.0206 19.4185L5.44441 17.8673L5.18159 17.6087C5.51884 16.9841 5.72463 15.9345 5.72463 15.0272C5.72463 14.462 6.0104 13.9859 6.29724 13.6659L6.65134 14.0099L11.184 18.4125L11.5128 18.7319C10.968 19.2051 10.1446 19.7341 9.53029 19.5272ZM12.2072 18.0123L11.8808 17.6952L7.34809 13.2925L7.02572 12.9794L16.7921 3.20811C17.1829 2.81714 17.8167 2.81738 18.2072 3.20865L21.3341 6.34189C21.708 6.71655 21.7252 7.31769 21.3733 7.7131L12.2072 18.0123Z"
            stroke="none"
        />
        <path d="M14 21H22" strokeWidth="1.5" strokeLinecap="round" />
    </svg>,
    'RoundedHighlight'
);

export const SideboardIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M18 4.5H6C4.34315 4.5 3 5.84315 3 7.5V15C3 16.6569 4.34315 18 6 18H18C19.6569 18 21 16.6569 21 15V7.5C21 5.84315 19.6569 4.5 18 4.5Z"
            strokeWidth="1.5"
        />
        <path d="M10.5 4.5V18" strokeWidth="1.5" />
        <circle cx="6.5" cy="8" r="0.5" strokeWidth="1.5" />
        <circle cx="6.5" cy="12.5" r="0.5" strokeWidth="1.5" />
    </svg>,
    'SideboardIcon'
);

export const UserDetailIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M12.5 12C13.8261 12 15.0979 11.4732 16.0355 10.5355C16.9732 9.59785 17.5 8.32608 17.5 7C17.5 5.67392 16.9732 4.40215 16.0355 3.46447C15.0979 2.52678 13.8261 2 12.5 2C11.1739 2 9.90215 2.52678 8.96447 3.46447C8.02678 4.40215 7.5 5.67392 7.5 7C7.5 8.32608 8.02678 9.59785 8.96447 10.5355C9.90215 11.4732 11.1739 12 12.5 12Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.0902 22C21.0902 18.13 17.2402 15 12.5002 15C7.76016 15 3.91016 18.13 3.91016 22"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'UserIcon'
);

export const UploadIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path
            d="M9 17V11L7 13"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 11L11 13"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'UploadIcon'
);

export const UserIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        stroke="currentColor"
        width="24"
        height="24"
    >
        <path d="M20.7301 4.58977L20.7301 4.59048C20.7311 5.32519 20.4461 6.03145 19.9353 6.55963C19.4452 7.06649 18.7842 7.37114 18.0827 7.41578C18.0732 7.41434 18.0659 7.41351 18.0611 7.41298C18.0384 7.41046 18.0202 7.41002 18.0136 7.40989L18.0041 7.40977L18.0001 7.40977H17.8783C16.2541 7.35442 15.0701 6.10957 15.0701 4.58977C15.0701 3.02688 16.3452 1.75977 17.9001 1.75977C19.4539 1.75977 20.7301 3.03591 20.7301 4.58977ZM17.9029 2.24977V2.24977H17.9001C16.6139 2.24977 15.5701 3.29362 15.5701 4.57977C15.5701 5.83881 16.5526 6.85856 17.8099 6.90936L18.0287 6.9182L18.0379 6.90901L18.043 6.90868C18.6457 6.86894 19.2095 6.59688 19.6156 6.14979C20.0218 5.70269 20.2386 5.11544 20.2205 4.51168C20.2023 3.90792 19.9506 3.33475 19.5184 2.91285C19.0861 2.49096 18.507 2.25325 17.9029 2.24977Z" />
        <path
            d="M18.01 15.2801C17.62 15.2801 17.23 15.2502 16.84 15.1802C16.7427 15.1632 16.6498 15.1273 16.5664 15.0744C16.4831 15.0215 16.411 14.9526 16.3544 14.8718C16.2977 14.791 16.2575 14.6998 16.2362 14.6034C16.2149 14.507 16.2127 14.4073 16.23 14.3102C16.2469 14.2129 16.2829 14.1199 16.3358 14.0366C16.3887 13.9533 16.4575 13.8812 16.5383 13.8245C16.6192 13.7678 16.7104 13.7277 16.8068 13.7063C16.9032 13.685 17.0028 13.6829 17.1 13.7001C18.33 13.9101 19.63 13.6802 20.5 13.1002C20.97 12.7902 21.22 12.4001 21.22 12.0101C21.22 11.6202 20.96 11.2401 20.5 10.9302C19.63 10.3502 18.31 10.1201 17.07 10.3401C16.66 10.4201 16.27 10.1401 16.2 9.73015C16.13 9.32015 16.4 8.93015 16.81 8.86015C18.44 8.57015 20.13 8.88015 21.33 9.68015C22.21 10.2701 22.72 11.1101 22.72 12.0101C22.72 12.9001 22.22 13.7502 21.33 14.3502C20.42 14.9502 19.24 15.2801 18.01 15.2801Z"
            stroke="none"
        />
        <path
            d="M5.96998 7.91H5.94998C5.08724 7.88299 4.26884 7.52145 3.6679 6.90184C3.06695 6.28223 2.7306 5.45316 2.72998 4.59C2.72998 2.75 4.22998 1.25 6.05998 1.25C7.88998 1.25 9.38998 2.75 9.38998 4.58C9.38998 6.39 7.97998 7.85 6.17998 7.91L5.96998 7.16L6.03998 7.91H5.96998ZM6.06998 6.41C6.12998 6.41 6.17998 6.41 6.23998 6.42C7.12998 6.38 7.90998 5.58 7.90998 4.59C7.90945 4.23244 7.80417 3.88286 7.60717 3.58447C7.41016 3.28607 7.13005 3.05192 6.80145 2.91095C6.47285 2.76999 6.11015 2.72837 5.75816 2.79126C5.40616 2.85414 5.08031 3.01876 4.82084 3.26478C4.56137 3.51081 4.37966 3.82746 4.29816 4.17561C4.21665 4.52376 4.23893 4.88816 4.36223 5.22379C4.48553 5.55942 4.70446 5.85158 4.99196 6.06417C5.27947 6.27676 5.62295 6.40046 5.97998 6.42C5.98998 6.41 6.02998 6.41 6.06998 6.41Z"
            stroke="none"
        />
        <path
            d="M5.96 15.2801C4.73 15.2801 3.55 14.9502 2.64 14.3502C1.76 13.7601 1.25 12.9102 1.25 12.0101C1.25 11.1202 1.76 10.2701 2.64 9.68015C3.84 8.88015 5.53 8.57015 7.16 8.86015C7.57 8.93015 7.84 9.32015 7.77 9.73015C7.7 10.1401 7.31 10.4201 6.9 10.3401C5.66 10.1201 4.35 10.3502 3.47 10.9302C3 11.2401 2.75 11.6202 2.75 12.0101C2.75 12.4001 3.01 12.7902 3.47 13.1002C4.34 13.6802 5.64 13.9101 6.87 13.7001C7.28 13.6301 7.67 13.9102 7.74 14.3102C7.81 14.7201 7.54 15.1101 7.13 15.1802C6.74 15.2502 6.35 15.2801 5.96 15.2801Z"
            stroke="none"
        />
        <path
            d="M12.0001 15.38H11.8701C9.98007 15.32 8.57007 13.86 8.57007 12.06C8.57007 10.22 10.0701 8.72998 11.9001 8.72998C13.7301 8.72998 15.2301 10.23 15.2301 12.06C15.2313 12.9246 14.8958 13.7558 14.2948 14.3774C13.6937 14.999 12.8743 15.3622 12.0101 15.39C12.0101 15.38 12.0101 15.38 12.0001 15.38ZM11.9001 10.22C10.8901 10.22 10.0701 11.04 10.0701 12.05C10.0701 13.04 10.8401 13.84 11.8301 13.88C11.8401 13.87 11.9201 13.87 12.0101 13.88C12.9801 13.83 13.7301 13.03 13.7401 12.05C13.7401 11.05 12.9201 10.22 11.9001 10.22Z"
            stroke="none"
        />
        <path
            d="M12 22.7602C10.8 22.7602 9.60003 22.4502 8.67003 21.8202C7.79003 21.2302 7.28003 20.3902 7.28003 19.4902C7.28003 18.6002 7.78003 17.7402 8.67003 17.1502C10.54 15.9102 13.47 15.9102 15.33 17.1502C16.21 17.7402 16.72 18.5802 16.72 19.4802C16.72 20.3702 16.22 21.2302 15.33 21.8202C14.4 22.4402 13.2 22.7602 12 22.7602ZM9.50003 18.4102C9.03003 18.7202 8.78003 19.1102 8.78003 19.5002C8.78003 19.8902 9.04003 20.2702 9.50003 20.5802C10.85 21.4902 13.14 21.4902 14.49 20.5802C14.96 20.2702 15.21 19.8802 15.21 19.4902C15.21 19.1002 14.95 18.7202 14.49 18.4102C13.15 17.5002 10.86 17.5102 9.50003 18.4102Z"
            stroke="none"
        />
    </svg>,
    'UserIcon'
);
